/**
 * Filter layout for the OM Sales Order "Select Items" popup (legacy OMD0027).
 * Drives the <FormField> filter panel; the values are turned into a DevExtreme filter by
 * buildDxFilters and applied server-side to the GetItemsForSelection grid.
 *
 * Every field `name` matches an ItemDto / grid column (IM ItemService.GetItems), so the
 * filter targets that column. All non-GUID item columns are included; the common ones are visible
 * by default and the rest are hidden (re-enableable via the dynamic form designer).
 */
const text = (name, label, visible = false) => ({
    name,
    tableName: "IMITEM",
    label,
    type: "text",
    required: false,
    visible,
    ignoredblocalization: true,
    isLabelChanged: false,
});
const number = (name, label, visible = false) => ({ ...text(name, label, visible), type: "number" });
const date = (name, label, visible = false) => ({ ...text(name, label, visible), type: "date" });
const range10 = Array.from({ length: 10 }, (_, i) => i + 1);

export const SelectItemsSearchLayout = [
    {
        groupId: 1,
        fields: [
            text("WarehouseName", "Warehouse", true),
            text("Description1", "Description 1 - Item", false),
            text("Description2", "Description 2 - Item", false),
            text("ClassCode", "Class Code", false),
            text("SubClassCode", "Sub Class Code", false),
        ],
    },
    {
        groupId: 2,
        fields: [
            text("ItemCode", "Item Code", true),
            text("ProfileCode", "Profile Code", false),
            text("Status", "Status", false),
            text("ItemType", "Item Type", false),
            text("TaxStatus", "Tax Status", false),
        ],
    },
    {
        groupId: 3,
        fields: [
            text("ItemSourceFlag", "Item Source Flag"),
            text("FreightClassCode", "Freight Class Code"),
            text("PhysicalCountCode", "Physical Count Code"),
            text("InventoryUnitUom", "Inventory Unit UOM"),
            number("Available", "Item - Avl"),
            number("NetAvailable", "Item - Net Avl"),
            number("OnHand", "On Hand"),
        ],
    },
    {
        groupId: 4,
        fields: [
            ...range10.map((i) => text(`UserDefinedCode${i}`, `User Defined Code ${i}`)),
            ...range10.map((i) => text(`UserDefinedReference${i}`, `User Defined Reference ${i}`)),
            ...range10.map((i) => number(`UserDefinedQuantity${i}`, `User Defined Quantity ${i}`)),
            ...range10.map((i) => date(`UserDefinedDate${i}`, `User Defined Date ${i}`)),
        ],
    },
];
